module.exports = "/_next/static/images/Brent-3a2fd5e258b3d766c1d663a82ed5637e.jpg";